import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { revaluation as rules } from 'further-ui/validations';

type Options = {
  skipReset?: boolean;
};

const useRevaluationFormSync = (
  formMethods: UseFormReturn<rules.RevaluationFormType>,
  savedData: rules.RevaluationFormType | undefined,
  onChange: (data: rules.RevaluationFormType) => void,
  options?: Options,
) => {
  useEffect(() => {
    if (!options?.skipReset && savedData) formMethods.reset(savedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { unsubscribe } = formMethods.watch(() => {
      onChange(formMethods.getValues());
    });
    // Emit current form values so that any setValue calls from child effects
    // (which fire before parent effects) are captured by the parent state.
    onChange(formMethods.getValues());
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useRevaluationFormSync;
